import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { trendingItemService } from './trending-item.schema';
import { ZodError } from 'zod';
import { toast } from 'react-toastify';

export const useGetTrendingItems = () => {
  return useQuery({
    queryKey: ['trending-items'],
    queryFn: async () => {
      try {
        if (process.env.REACT_APP_API_BASE_TRENDINGITEM_URL) {
          const response = await axios.get(process.env.REACT_APP_API_BASE_TRENDINGITEM_URL);

          const data = trendingItemService.parse(response.data.data);

          return data;
        }
      } catch (error: unknown) {
        if (error instanceof ZodError) {
          console.error(error);
          toast.error('API validation failed');
        }

        console.error(error);
      }
    },
  });
};
